module.exports = __webpack_public_path__ + "static/media/plane.05a9dc01.mp4";